<template>
    <div class="lives-list-section">
        <!--layout1 4直播 -->
        <van-row @click="go_live_detail(dataItem)">
            <div class="lives-list-section-box">
                <div class="lives-list-section-left">
                    <img class="lives-list-section-left-img" :src="dataItem.cover_img" />
                    <div v-if="dataItem.type == 2" class="lives-list-section-left-zl">
                        <img src="static/v4/icon_list_tag_column.svg" class="img1">
                    </div>
                    <div v-else-if="dataItem.live_status == 0" class="lives-list-section-left-zl">
                        <img src="/static/v4/icon_list_tag_live_count_down.svg" class="img2">
                    </div>
                    <div v-else-if="dataItem.live_status == 1" class="lives-list-section-left-zl">
                        <img src="/static/v4/icon_list_tag_live_process.svg" class="img3">
                    </div>
                    <div v-else class="lives-list-section-left-zl">
                        <img src="static/v4/icon_list_tag_live_history.svg" class="img1">
                    </div>
                </div>
                <div class="lives-list-section-right">
                    <div class="lives-list-section-right-title" v-html="dataItem.title"></div>
                    <div class="lives-list-section-right-detail chu" style="bottom: 0" v-if="dataItem.type === 2">
                      <span>共{{ dataItem.total_count }}期</span>
                      <span style="margin-left: 8px">{{ dataItem.view_count }}人观看</span>
                    </div>
                    <div class="lives-list-section-right-detail" style="bottom: 0" v-else-if="dataItem.live_status == 0">
                        <span>{{ dataItem.start_at }}</span>
                        <span class="live-list-section-right-detail-join" @click.stop="liveApply(item,item.origin_id)" v-if="dataItem.live_status == 0 && dataItem.isAppointment == 0">一键预约</span>
                        <span class="live-list-section-right-detail-join" v-else-if="dataItem.live_status == 0 && dataItem.isAppointment == 1">已预约</span>
                    </div>
                    <div class="lives-list-section-right-detail" style="bottom: 0" v-else-if="dataItem.live_status == 1">
                        <span>{{ dataItem.start_at }}</span>
                        <span class="lives-list-section-right-detail-join">加入</span>
                    </div>
                    <div class="lives-list-section-right-detail" style="bottom: 0" v-else>
                        <span>{{ dataItem.view_count }}人观看</span>
                    </div>
                </div>
            </div>
        </van-row>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },

    methods: {
        go_live_detail(item) {
            Interface.getData('get', `/course/api/content_relation/${item.id}/view`)
            this.getViewCount(item)
            Interface.goLiveDetail(this, {id: item.origin_id, type: item.type, isAppointment: item.isAppointment, live_status: item.live_status})
            Interface.mFootPrint(item.origin_id,4,0,5,0, item.title)
        },
        // 直播-一键预约
        liveApply(item,id) {
            console.log(123123)
            this.liveItem = item
            if (!item.isAppointment) {
                // 判断是否认证 0 未认证   1已认证
                let user = localStorage.getItem('user')

                let is_complete = JSON.parse(user).is_complete

                if (is_complete == 1) {
                    Interface.getData('get', Interface.v4.apply + '/' + id).then(res => {
                        if (res.code == 0) {
                            this.applyShow = true
                        }
                    })
                } else {
                    // 去认证
                    this.$dialog
                        .confirm({
                            title: '需要登录',
                            message: '为了方便学习课程,需要您登录认证',
                            confirmButtonText: '去认证'
                        })
                        .then(() => {
                            sessionStorage.setItem('back-url', this.$route.path)
                            this.$router.push({ name: 'login' })
                        })
                        .catch(() => {
                            // on cancel
                        })
                }
            }else{
                Interface.goLiveDetail(this, item)
            }
        },
        getViewCount(item) {
            Interface.getData('get', `/course-phase/api/recommend_v2/${item.id}/view`)
        }
    }
}
</script>

<style lang="scss" scoped>
.lives-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 12px 10px 12px;
    background-color: #ffffff;
    margin: 10px 0;
    border-radius: 10px;

    &-title {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #222222;
        letter-spacing: 0;
        margin-left: 16px;
        font-weight: 500;
        position: relative;
        span {
            position: absolute;
            bottom: 0vw;
            left: 0;
            width: 30px;
            height: 6px;
            background-color: #c7f3e7;
            border-radius: 0.8vw;
            z-index: 1;
        }
    }

    &-box {
        // width: 355px;
        height: 72px;
        position: relative;
        padding-bottom: 15px;
        padding-bottom: 0;
    }

    &-left {
        width: 130px;
        height: 73px;
        float: left;
        position: relative;
        border-radius: 6px;
        // margin-left: 10px;
        &-img {
            width: 130px;
            height: 73px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            //background: #10c3b5;
            //border-radius: 6px 3px 3px 3px;
            //font-family: PingFangSC-Medium;
            //font-size: 10px;
            //color: #ffffff;
            //letter-spacing: 0;
            //padding: 1px 6px;
            .img1 {
                width: 30px;
                height: 18px;
            }
            .img2 {
                width: 40px;
                height: 18px;
            }
            .img3 {
                width: 50px;
                height: 18px;
            }
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            &.current {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
                font-family: PingFangSC-Medium;
                font-size: 10px;
                color: #ffffff;
                letter-spacing: 0;
                img {
                    width: 12px;
                    height: 12px;
                    margin-bottom: -3px;
                }
            }
        }
        &-time {
            width: 100%;
            bottom: 0px;
            position: absolute;
            color: #fff;

            font-family: Avenir-Heavy;
            font-size: 11px;
            letter-spacing: 0;
            text-align: right;

            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
            border-radius: 0 0 6px 6px;

            span {
                display: inline-block;
                margin-bottom: 4px;
                margin-right: 8px;
            }
        }
        &-top{
            position: absolute;
            top: 4px;
            left: 4px;
            width: 18px;
            height: 18px;
            border-radius: 3px;
            img {
                width: 18px;
                height: 18px;
                border-radius: 3px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 10px;
        text-align: left;
        &-title {
            font-family: PingFangSC-Medium, PingFang SC;
            font-size: 14px;
            color: #222222;
            letter-spacing: 0;
            line-height: 22px;
            font-weight: 500;
            // text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
            /deep/ .light {
                color: #D81D20;
            }
        }
        &-author {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #404040;
            letter-spacing: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
        }
        &-detail {
            width: 193px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9d9d9d;
            letter-spacing: 0;

            text-align: left;
            position: absolute;
            bottom: 15px;
            word-break: break-all;
            &-join {
                float: right;
                display: inline-block;
                font-family: PingFangSC-Medium;
                font-size: 13px;
                color: #d81d20;

                background: #ffece8;
                border-radius: 16.5px;

                padding: 5px 8px;
                margin-top: -10px;
                margin-left: 5px;
            }
        }
      .chu{
        display: inline-block;
      }
    }

    .lives-list-section-left {
    }
    .lives-list-section-right {
        width: 191px;
    }
    .lives-list-section {
        padding-top: 14px;
        margin-top: 0px;

        // .course-list-section-right-title,
        .lives-list-section-right-title {
            padding-right: 14px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
        }
    }
}

.ellipsis-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/hotRecommend/layout1/lives.vue